module.exports = __webpack_public_path__ + "img/sphere04-graph.b12198a7.png";